import { create } from 'zustand'

export type UserPersonalDefaults = {
  setupCompleted: boolean
  branchId?: string
  storeId?: string
  cashAccountId?: string
  contactId?: string
  paymentMethodId?: number
  salesRepId?: number
  invoiceSettingsId?: number
}

type UserDefaultsState = {
  loaded: boolean
  defaults: UserPersonalDefaults
  /** Force open wizard from settings even if already completed */
  forceWizardOpen: boolean
  setFromApi: (raw: any) => void
  setDefaults: (partial: Partial<UserPersonalDefaults>) => void
  setForceWizardOpen: (open: boolean) => void
  clear: () => void
  needsWizard: () => boolean
}

const emptyDefaults: UserPersonalDefaults = {
  setupCompleted: false,
}

function normalizeDefaults(raw: any): UserPersonalDefaults {
  if (!raw || typeof raw !== 'object') return { ...emptyDefaults }
  return {
    setupCompleted: raw.setupCompleted === true || raw.SetupCompleted === true,
    branchId: raw.branchId ?? raw.BranchId ?? undefined,
    storeId: raw.storeId ?? raw.StoreId ?? undefined,
    cashAccountId: raw.cashAccountId ?? raw.CashAccountId ?? undefined,
    contactId: raw.contactId ?? raw.ContactId ?? undefined,
    paymentMethodId:
      raw.paymentMethodId != null
        ? Number(raw.paymentMethodId)
        : raw.PaymentMethodId != null
          ? Number(raw.PaymentMethodId)
          : undefined,
    salesRepId:
      raw.salesRepId != null
        ? Number(raw.salesRepId)
        : raw.SalesRepId != null
          ? Number(raw.SalesRepId)
          : undefined,
    invoiceSettingsId:
      raw.invoiceSettingsId != null
        ? Number(raw.invoiceSettingsId)
        : raw.InvoiceSettingsId != null
          ? Number(raw.InvoiceSettingsId)
          : undefined,
  }
}

export const useUserDefaultsStore = create<UserDefaultsState>((set, get) => ({
  loaded: false,
  defaults: { ...emptyDefaults },
  forceWizardOpen: false,

  setFromApi: (raw) => {
    set({
      loaded: true,
      defaults: normalizeDefaults(raw),
    })
  },

  setDefaults: (partial) => {
    set((state) => ({
      loaded: true,
      defaults: { ...state.defaults, ...partial },
    }))
  },

  setForceWizardOpen: (open) => set({ forceWizardOpen: open }),

  clear: () =>
    set({
      loaded: false,
      defaults: { ...emptyDefaults },
      forceWizardOpen: false,
    }),

  needsWizard: () => {
    const { loaded, defaults, forceWizardOpen } = get()
    if (forceWizardOpen) return true
    if (!loaded) return false
    return !defaults.setupCompleted
  },
}))
